export default __webpack_public_path__ + "static/Activity-4x3-S_Cycle-daef329edcbbec3eeb3a029b8171536a.png";